import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectItalyFiscalCodesManagement } from '../italyFiscalCodesManagementSelectors'
import { closeModal } from '../italyFiscalCodesManagementSlice'

const useLocationModal = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { table, isModalOpen, draft, isSaving } = useSelector(selectItalyFiscalCodesManagement)

  const isEdit = draft.id !== null

  const onOpenChange = (open: boolean) => {
    if (open || isSaving) return
    dispatch(closeModal())
  }

  return {
    isOpen: isModalOpen,
    title: t(`italyFiscalCodesManagement:modal.${isEdit ? 'title_edit' : 'title_create'}.${table}`),
    onOpenChange,
  }
}

export default useLocationModal
